"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.removeInternalRepaymentTapeArtifacts = exports.addInternalRepaymentTapeArtifacts = void 0;
const lodash = __importStar(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const tape_builder_base_1 = require("../types/tape-builder-base");
const { cloneDeep } = lodash;
const INTERNAL_REPAYMENT_SLUG = 'InternalRepayment';
const createInternalRepaymentTapeSlug = (generateRepaymentTapeSlug) => {
    // Leverage existing unique "generatedRepaymentTape" slug
    // Substitute with "InternalRepayment" if it contains "GeneratedRepayment", otherwise just append
    if (generateRepaymentTapeSlug.toLowerCase().includes('generatedrepayment')) {
        return generateRepaymentTapeSlug.replace(/GeneratedRepayment/gi, INTERNAL_REPAYMENT_SLUG);
    }
    return `${generateRepaymentTapeSlug}-${INTERNAL_REPAYMENT_SLUG}`;
};
const createInternalRepaymentTapeArtifact = (params) => {
    const { generatedRepaymentTape, rawRepaymentTape, masterLoanTape } = params;
    const { loanProductSlug, artifactDocumentId, artifactSlug, creditFacilitySlug, } = generatedRepaymentTape;
    (0, common_1.finleyAssert)(loanProductSlug, 'loanProductSlug of generatedRepaymentTape must be defined');
    const newInternalRepaymentTape = {
        id: (0, uuid_1.v4)(),
        type: 'internalRepaymentTape',
        artifactSlug: createInternalRepaymentTapeSlug(artifactSlug),
        artifactDocumentId,
        loanProductSlug,
        creditFacilitySlug,
        externalFilename: null,
        configuration: {
            rawRepaymentTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(rawRepaymentTape.artifactSlug),
            generatedRepaymentTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(artifactSlug),
            masterLoanTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(masterLoanTape.artifactSlug),
        },
    };
    return newInternalRepaymentTape;
};
const _findMasterLoanTapeByGeneratedLoanTape = (inputs) => {
    const outputTapes = utils.getOutputTapes(inputs);
    const masterLoanTapes = outputTapes.filter(({ type }) => type === 'masterLoanTape');
    (0, common_1.finleyAssert)(masterLoanTapes.length === 1, `Expected 1 but found ${masterLoanTapes.length} masterLoanTapes for [inputArtifactId:${inputs.inputArtifactId}]`);
    return masterLoanTapes[0];
};
/**
 * Inserts new "InternalRepaymentTape" artifact between "GeneratedRepaymentTape" and output artifact
 * Currently, output is mainly "AssignedRepaymentTape" but this is not a strict constraint.
 * Mainly need to add new artifact to dataTapes and update dependencies connecting to new artifact
 *
 *                        *** Current ***
 * +------------------------+                  +-----------------------+
 * | GeneratedRepaymentTape | ---(optional)--> | AssignedRepaymentTape |
 * +------------------------+                  +-----------------------+
 *
 *                        *** Revised ***
 * +------------------------+        +-----------------------+                  +-----------------------+
 * | GeneratedRepaymentTape | -----> | InternalRepaymentTape | ---(optional)--> | AssignedRepaymentTape |
 * +------------------------+        +-----------------------+                  +-----------------------+
 *                                      ^   ^
 * +------------------------+           |   |
 * |    RawRepaymentTape    | ----------+   |
 * +------------------------+               |
 *                                          |
 * +------------------------+               |
 * |     MasterLoanTape     +---------------+
 * +------------------------+
 *
 * "RawRepaymentTape" & "GeneratedRepaymentTape" help contribute to "Internal" configuration and references
 * "MasterLoanTape" is needed to ensure receivables are available to get tagged with
 */
const addInternalRepaymentTapeArtifacts = (dbGraph) => {
    // Check for "GeneratedRepaymentTapes", as they will act as our basis for this synthetic transaction
    // It there aren't, can simply just return back early since nothing to mutate
    // Otherwise, deep clone and then mutate accordingly to include new "Internal" version
    const generatedRepaymentTapesInGraph = utils.filterGeneratedRepaymentTapes({
        dataTapes: dbGraph.dataTapes,
    });
    if (generatedRepaymentTapesInGraph.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = cloneDeep(dbGraph);
    const { dataTapes } = clonedDbGraph;
    let { dataTapeDependencies } = clonedDbGraph;
    // Update each "GeneratedRepaymentTape" in the graph
    for (const generatedRepaymentTape of generatedRepaymentTapesInGraph) {
        // Fetch all the needed tapes and dependencies first before mutating them
        const rawRepaymentTape = utils.findArtifactBySlugAndValidateLp({
            dataTapes,
            artifactSlug: generatedRepaymentTape.configuration.rawRepaymentTapeArtifactSlug,
            loanProductSlug: generatedRepaymentTape.loanProductSlug,
        });
        const generatedLoanTape = utils.findArtifactBySlugAndValidateLp({
            dataTapes,
            artifactSlug: generatedRepaymentTape.configuration.generatedLoanTapeArtifactSlug,
            loanProductSlug: generatedRepaymentTape.loanProductSlug,
        });
        const masterLoanTape = _findMasterLoanTapeByGeneratedLoanTape({
            dbGraph,
            inputArtifactId: generatedLoanTape.id,
        });
        // Get "GeneratedRepaymentTape" dependencies where they're acting as input artifacts
        // Then can manage dependencies to these target "GeneratedRepaymentTape" artifacts
        const generatedRepaymentTapeInputDependencies = utils.getDependenciesByInputId({
            dataTapeDependencies,
            inputArtifactId: generatedRepaymentTape.id,
        });
        // Create new "InternalRepaymentTape" from "GeneratedRepaymentTape" and add to graph
        const newInternalRepaymentTape = createInternalRepaymentTapeArtifact({
            rawRepaymentTape,
            generatedRepaymentTape,
            masterLoanTape,
        });
        dataTapes.push(newInternalRepaymentTape);
        // Add new graph-edge inputs into new "InternalRepaymentTape"
        // "RawRepaymentTape" & "GeneratedRepaymentTape" as associated repayment flows
        // "MasterLoanTape" to ensure receivables are available to attach Finley Receivable Id during creation
        dataTapeDependencies.push({
            inputArtifactId: rawRepaymentTape.id,
            outputArtifactId: newInternalRepaymentTape.id,
        });
        dataTapeDependencies.push({
            inputArtifactId: generatedRepaymentTape.id,
            outputArtifactId: newInternalRepaymentTape.id,
        });
        dataTapeDependencies.push({
            inputArtifactId: masterLoanTape.id,
            outputArtifactId: newInternalRepaymentTape.id,
        });
        for (const generatedRepaymentDependency of generatedRepaymentTapeInputDependencies) {
            // Removing existing dependency between "GeneratedRepaymentTape" and output artifact
            // since adding new "InternalRepaymentTape" connection in between
            dataTapeDependencies = utils.removeDependency({
                dataTapeDependencies,
                dependencyToRemove: generatedRepaymentDependency,
            });
            // Add new graph-edge between new "InternalRepaymentTape" to existing output artifact
            dataTapeDependencies.push({
                inputArtifactId: newInternalRepaymentTape.id,
                outputArtifactId: generatedRepaymentDependency.outputArtifactId,
            });
        }
    }
    return { dataTapeDependencies, dataTapes };
};
exports.addInternalRepaymentTapeArtifacts = addInternalRepaymentTapeArtifacts;
/*
 * Removes "InternalRepaymentTape" artifact from graph and reconstructs connection
 * between "GeneratedRepaymentTape" and prior output (e.g., "AssignedRepaymentTape")
 *
 *                        *** Current ***
 * +------------------------+        +-----------------------+        +-----------------------+
 * | GeneratedRepaymentTape | -----> | InternalRepaymentTape | -----> | AssignedRepaymentTape |
 * +------------------------+        +-----------------------+        +-----------------------+
 *                                      ^   ^
 * +------------------------+           |   |
 * |    RawRepaymentTape    | ----------+   |
 * +------------------------+               |
 *                                          |
 * +------------------------+               |
 * |    MasterLoanTape *    +---------------+
 * +------------------------+
 *
 *                        *** Revised ***
 * +------------------------+        +-----------------------+
 * | GeneratedRepaymentTape | -----> | AssignedRepaymentTape |
 * +------------------------+        +-----------------------+
 *
 * Note that "MasterLoanTape" might already have been removed due to prior detach synthetic process
 */
const removeInternalRepaymentTapeArtifacts = (dbGraph) => {
    const internalRepaymentTapesInGraph = utils.filterInternalRepaymentTapes({
        dataTapes: dbGraph.dataTapes,
    });
    if (internalRepaymentTapesInGraph.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = cloneDeep(dbGraph);
    const { dataTapes } = clonedDbGraph;
    let { dataTapeDependencies } = clonedDbGraph;
    // Currently for "InternalRepaymentTapes", it expects:
    // Inputs: 1 "RawRepaymentTape" + 1 "GeneratedRepaymentTape" + 1 "MasterLoanTape" (optional)
    // Outputs: multiple and flexible for output artifacts
    for (const internalRepaymentTape of internalRepaymentTapesInGraph) {
        // Fetch associated "MasterLoanTape" to "InternalRepaymentTape" to cut dependency
        // Note that "MasterLoanTape" might have already been removed due to prior detach synthetic process
        const masterLoanTape = utils.findOptionalArtifactBySlug({
            dataTapes,
            artifactSlug: internalRepaymentTape.configuration.masterLoanTapeArtifactSlug,
        });
        // Remove synthetic "InternalRepaymentTape" artifact from dataTapes
        dataTapes.splice(utils.findTapeIndex({ dataTapes, tape: internalRepaymentTape }), 1);
        const internalRepaymentTapeInputs = utils.getInputTapes({
            dbGraph: clonedDbGraph,
            outputArtifactId: internalRepaymentTape.id,
        });
        const expectedInputCounts = 2 + (masterLoanTape ? 1 : 0);
        (0, common_1.finleyAssert)(internalRepaymentTapeInputs.length === expectedInputCounts, `Expected ${expectedInputCounts} input dependencies for InternalRepaymentTape, found [${internalRepaymentTapeInputs.length}]`);
        if (masterLoanTape) {
            dataTapeDependencies = utils.removeDependency({
                dataTapeDependencies,
                dependencyToRemove: {
                    inputArtifactId: masterLoanTape.id,
                    outputArtifactId: internalRepaymentTape.id,
                },
            });
        }
        // Fetch associated "RawRepaymentTape" to "InternalRepaymentTape" to cut dependency
        const rawRepaymentTape = utils.findArtifactBySlug({
            dataTapes,
            artifactSlug: internalRepaymentTape.configuration.rawRepaymentTapeArtifactSlug,
        });
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: {
                inputArtifactId: rawRepaymentTape.id,
                outputArtifactId: internalRepaymentTape.id,
            },
        });
        // Fetch associated "GeneratedRepaymentTape" to "InternalRepaymentTape"
        // Cut the dependency and also re-add "GeneratedRepaymentTape" output dependency
        const generatedRepaymentTape = utils.findArtifactBySlug({
            dataTapes,
            artifactSlug: internalRepaymentTape.configuration.generatedRepaymentTapeArtifactSlug,
        });
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: {
                inputArtifactId: generatedRepaymentTape.id,
                outputArtifactId: internalRepaymentTape.id,
            },
        });
        // Recall that output artifacts are not strict and can be multiple artifacts
        const internalRepaymentTapeOutputs = utils.getOutputTapes({
            dbGraph: clonedDbGraph,
            inputArtifactId: internalRepaymentTape.id,
        });
        for (const outputArtifact of internalRepaymentTapeOutputs) {
            // Remove output dependency with synthetic "InternalRepaymentTape"
            dataTapeDependencies = utils.removeDependency({
                dataTapeDependencies,
                dependencyToRemove: {
                    inputArtifactId: internalRepaymentTape.id,
                    outputArtifactId: outputArtifact.id,
                },
            });
            // Re-add connection between "GeneratedRepaymentTape" and existing output artifact
            dataTapeDependencies.push({
                inputArtifactId: generatedRepaymentTape.id,
                outputArtifactId: outputArtifact.id,
            });
        }
    }
    return { dataTapeDependencies, dataTapes };
};
exports.removeInternalRepaymentTapeArtifacts = removeInternalRepaymentTapeArtifacts;
exports.syntheticProcess = {
    toDb: exports.addInternalRepaymentTapeArtifacts,
    fromDb: exports.removeInternalRepaymentTapeArtifacts,
};
//# sourceMappingURL=internalRepaymentTape.js.map